function useLanguage(messageObj) {
    const language = "en"; // set default language as "en"
    return messageObj[language];
}

export default useLanguage;